import axios from 'axios';

export const webpayToken = (data) => axios.post('/b/webpay/transaction', { ...data });
